export * from "/__w/wiggot-web/wiggot-web/packages/web-components/store/modals/modal-archive-property.store.ts"